import DefaultCompanyBankAccountBenefitsBanner from "./DefaultCompanyBankAccountBenefitsBanner";

export default DefaultCompanyBankAccountBenefitsBanner;
